import { DateType, dateFromNow, formatDate } from "src/utils/datetime";

type DateProps = {
  value: DateType;
  format: string;
};

const FULL_DATE_TIME_FORMAT = "MMM dd, yyyy 'at' h:mm aa";
const FULL_DATE_TIME_FORMAT_WITH_TIMEZONE = "MMM dd, yyyy 'at' h:mm aa zzz";

type SpecifiedFormatDateProps = Pick<DateProps, "value">;

const DisplayDateBase: React.FC<DateProps> = ({ value, format }) => {
  return <span>{formatDate(value, format)}</span>;
};

export const DisplayDateTime: React.FC<
  SpecifiedFormatDateProps & {
    timezone?: boolean;
  }
> = ({ value, timezone = false }) => {
  return (
    <DisplayDateBase
      format={
        timezone ? FULL_DATE_TIME_FORMAT_WITH_TIMEZONE : FULL_DATE_TIME_FORMAT
      }
      value={value}
    />
  );
};

export const DisplayDate: React.FC<SpecifiedFormatDateProps> = ({ value }) => {
  return <DisplayDateBase format="MMM dd, yyyy" value={value} />;
};

type DisplayDateFromNowProps = SpecifiedFormatDateProps & {
  withoutSuffix?: boolean;
  allowFuture?: boolean;
};

export const DisplayDateFromNow: React.FC<DisplayDateFromNowProps> = ({
  value,
  withoutSuffix = false,
  allowFuture = false,
}) => {
  return <span>{dateFromNow(value, withoutSuffix, allowFuture)}</span>;
};
